import { channelPartnerKeyScopeKey as e } from "./channelPartnerKeyScopeKey.mjs";
import { useTrEnumNamespace as t } from "./useTrEnumNamespace.mjs";
import { useCallback as n } from "react";
//#region src/enums/useTrAdminMcpKeyScopeDescription.ts
var r = () => {
	let r = t("adminMcpKeyScopeDescription");
	return n((t) => {
		let n = e(t), i = r(n);
		return i === n ? "" : i;
	}, [r]);
};
//#endregion
export { r as useTrAdminMcpKeyScopeDescription };
